import { useEffect } from "react";
import { useOpenAiGlobal } from "../use-openai-global";
import { createRoot } from "react-dom/client";
import { LoadingIndicator } from "@openai/apps-sdk-ui/components/Indicator";

interface DiagnoseOutput {
  resumePdf?: {
    file_id: string;
  };
  analysis?: string;
}

function App() {
  const toolOutput = useOpenAiGlobal("toolOutput") as DiagnoseOutput | null;
  const resumeDiagnose = toolOutput?.analysis;
  // console.log("Resume Diagnose:", resumeDiagnose);
  // useEffect(() => {
  //   console.log("Resume Diagnose on update:", resumeDiagnose);
  // }, [resumeDiagnose]);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
      { resumeDiagnose ? (
        <div className="flex items-center gap-2">
          <span>Resume Diagnosed Finish!</span>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <LoadingIndicator
            size = {20}
            strokeWidth={2}
          />
          Resume Diagnosing...
        </div>
      )
      }
      {/* <pre>{JSON.stringify(resumeStruct, null, 2)}</pre> */}
    </div>
  );
}

const root = document.getElementById("diagnose-resume-root");

if (root) {
  createRoot(root).render(<App />);
}
